(ns teamoesterreich.lebensretter-mode.widgets
  (:require [clojure.string]
            [goog.date.DateTime]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.cloud-upload :refer [cloud-upload]]
            [reagent.core :as r]
            [teamoesterreich.firebase.storage-provider :as storage-provider]
            [teamoesterreich.user-mode.actions :as a]
            [teamoesterreich.util.log :as log]))


(defn specific-upload-button [type !state !userId & [name]]
  (fn []
    (log/out "upload-part  -> " @!state @!userId)
    [:div {:className "specific-upload-button"}
     [:input {:accept "image/" :id "photoUpload" :type "file"
              :style  {:display "none"}}]
     [:label {:for "photoUpload"}



      [mui/button {
                   :variant   "outlined"
                   :startIcon (r/as-element [cloud-upload])
                   :component "label"
                   :style     {:width "200px"}
                   }
       (or name "Hochladen") (when (:progress @!state) (str " ... " (:progress @!state) "%"))
       [:input {:accept   "image/" :id "photoUpload"
                :type     "file"
                :hidden   true
                :onChange (fn [e]
                            (let [file (.item e.target.files 0)]
                              ;(log/out "################################################  upload fired..." @!userId " <" (:type @!state) "> file" file)
                              (storage-provider/upload-user-file file @!userId (:type @!state)
                                                                 (fn [path]
                                                                   (log/out "<<<<<<<<<<<<  upload callback fired " path)
                                                                   (a/add-user-document {:deleted false :locked false :path path :name (.-name file) :uploaded (js/Date.) :type type})
                                                                   (swap! !state assoc :progress nil))
                                                                 (fn [p] (swap! !state assoc :progress p)))
                              ))
                }]]

      ]
     ]
    )

  )


(defn document-view [!state file-name]
  (log/debug "document-view " file-name)
  (if (re-matches #"(?i).*(txt|pdf|doc|docx)$" file-name)
    [:img {:src       "/custom/img/file.png"
           :onClick   #(swap! !state assoc :enlarge (not (:enlarge @!state)))
           :className "helping-form-img"
           :alt       "Datei"}]
    [:img {:src       (:url @!state)
           :className "helping-form-img"
           :alt       "Ansicht"}]
    ))

